const getImageFullUrl = (imageName) => {
    const imageFullUrl = process.env.REACT_APP_S3_BASE_URL + imageName;
    return imageFullUrl
}

export { getImageFullUrl }